import Delta from 'quill-delta';
import getNodeLength from '../utils/getNodeLength';
import getNodeData from '../utils/getNodeData';
import { BLOCK_DELIMITER_LENGTH } from '../utils/constants';
import { OT_BLOCKS } from '../../../types/BlockTypes';
import convertPathToOffset from '../utils/convertPathToOffset';
export default function mergeNode(op, editor) {
  var node = editor.value.document.getNode(op.path);

  if (node && OT_BLOCKS.includes(node.type)) {
    var previousNode = editor.value.document.getPreviousNode(op.path);
    var retainBefore = convertPathToOffset(editor.value.document, op.path);
    var retainAfter = getNodeLength(node);
    return new Delta().retain(retainBefore - BLOCK_DELIMITER_LENGTH)["delete"](BLOCK_DELIMITER_LENGTH).retain(retainAfter - BLOCK_DELIMITER_LENGTH).retain(BLOCK_DELIMITER_LENGTH, {
      type: previousNode.type,
      data: getNodeData(previousNode)
    });
  }
}